@if (serviceId()) {
    <ng-template pTemplate="header">
        <div class="title">{{ 'service.payments.form.title' + (updateId() ? 'Edit' : 'Create') | translate }}</div>
    </ng-template>
    <div class="grid-5col input-grid-gaps">
        <app-insurance-company-select-input
            id="insuranceCompanyId"
            [form]="form"
            label="service.payments.form.insuranceCompany"
            valueKey="id"
            [disabled]="!!updateId()"
        ></app-insurance-company-select-input>

        <app-select-input
            id="insuranceType"
            [form]="form"
            [staticOptions]="insuranceTypeEnumOptions"
            label="service.payments.form.insuranceType"
            valueKey="value"
            [disabled]="!!updateId()">
        </app-select-input>

        <app-date-input
            [form]="form"
            id="validFrom"
            label="service.payments.form.validFrom"
        ></app-date-input>
        <app-date-input
            [form]="form"
            id="validTo"
            label="service.payments.form.validTo"
        ></app-date-input>
        <app-text-input
            [form]="form"
            id="serviceICZ"
            label="service.payments.form.serviceICZ"
        ></app-text-input>

        @if (overlapErrorMessage()) {
            <app-error-float-message class="fr-5">
                <span>{{ overlapErrorMessage() }}</span>
            </app-error-float-message>
        }

        <div class="fr-5 margin-top">{{ 'service.payments.form.paymentsSubtitle' | translate }}:</div>

        <!-- TODO zatim skryto, nez se doresi pocitani vyuctovani -->
        <!--        <div class="form-line">-->
        <!--            <app-input-select-->
        <!--                [form]="form"-->
        <!--                id="paymentType"-->
        <!--                [options]="paymentTypes"-->
        <!--                label="service.payments.form.paymentType"-->
        <!--                namePrefix="billing.paymentType."-->
        <!--            ></app-input-select>-->
        <!--            @if (paymentTypeValue !== BillingPaymentTypeEnum.PROCEDURES) {-->
        <!--                <app-number-input-->
        <!--                    [form]="form"-->
        <!--                    id="paymentTypeAmount"-->
        <!--                    [label]="'service.payments.form.paymentTypeAmount_' + paymentTypeValue"-->
        <!--                ></app-number-input>-->
        <!--            }-->
        <!--            <div [ngClass]="{-->
        <!--                'fr-4': paymentTypeValue === BillingPaymentTypeEnum.PROCEDURES,-->
        <!--                'fr-3': paymentTypeValue !== BillingPaymentTypeEnum.PROCEDURES-->
        <!--             }"></div>-->
        <!--        </div>-->

        <div class="form-line">
            <app-select-input
                id="transportType"
                [form]="form"
                label="service.payments.form.transportType"
                [staticOptions]="transportTypes"
                valueKey="name">
                <ng-template #item let-data>
                    {{ ('billing.transportType.' + (data?.name ?? data)) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('billing.transportType.' + (data?.name ?? data)) | translate }}
                </ng-template>
            </app-select-input>
            <div class="fr-4"></div>
        </div>

        @if (form.value.transportType !== BillingTransportTypeEnum.NONE) {
            <div class="form-line">
                <app-number-input
                    [form]="form"
                    id="paymentForTransport"
                    label="service.payments.form.paymentForTransport"
                    [maxFractionDigits]="2"
                ></app-number-input>
                <div class="fr-4"></div>
            </div>
        }
        @if (form.value.transportType === BillingTransportTypeEnum.VISIT) {
            <app-check-input
                [form]="form"
                id="dontBillVisitsWithNoDistance"
                label="service.payments.form.dontBillVisitsWithNoDistance"
                class="fr-5"
            ></app-check-input>
        }
        @if (form.value.transportType === BillingTransportTypeEnum.VISIT) {
            <app-check-input
                [form]="form"
                id="reportTraveledDistanceToKdavka"
                label="service.payments.form.reportTraveledDistanceToKdavka"
                class="fr-5"
            ></app-check-input>
        }

        <div class="form-line">
            <app-number-input
                [form]="form"
                id="priceForPoint"
                label="service.payments.form.priceForPoint"
                [maxFractionDigits]="2"
            ></app-number-input>
            <div class="fr-4"></div>
        </div>

        <div class="form-line">
            <app-number-input
                [form]="form"
                id="pointsPerMinute"
                label="service.payments.form.pointsPerMinute"
                [maxFractionDigits]="2"
            ></app-number-input>
            <div class="fr-4"></div>
        </div>

        <div class="fr-5 margin-top">{{ 'service.payments.form.limitsSubtitle' | translate }}:</div>

        <div class="form-line">
            <app-number-input
                [form]="form"
                id="maximalMonthlyPrepaymentLimit"
                label="service.payments.form.maximalMonthlyPrepaymentLimit"
                class="fr-2"
            ></app-number-input>
            <div class="fr-3"></div>
        </div>

        <div class="fr-5 margin-top">{{ 'service.payments.form.invoiceInfosSubtitle' | translate }}:</div>

        <div class="form-line">
            <app-input-wysiwyg
                [form]="form"
                id="address"
                editorKey="ServicePaymentFormAddress"
                placeholder="service.payments.form.address"
                class="fr-2"
                [autocompleteOrganization]="true"
            ></app-input-wysiwyg>
            <app-text-area-input
                [form]="form"
                id="note"
                label="service.payments.form.note"
                class="fr-2"
            ></app-text-area-input>
            <div></div>
        </div>

        <div class="form-line">
            <app-number-input
                [form]="form"
                id="invoiceDueInDays"
                label="service.payments.form.invoiceDueInDays"
            ></app-number-input>
            <div class="fr-4"></div>
        </div>

        <div class="fr-5 margin-top">{{ 'service.payments.form.pohodaSubtitle' | translate }}:</div>

        <div class="form-line">
            <app-text-input
                [form]="form"
                id="pohodaInsuranceCompanyBranchName"
                label="service.payments.form.pohodaInsuranceCompanyBranch.name"
                class="fr-2"
            ></app-text-input>
            <div class="fr-3"></div>
        </div>

        <div class="form-line">
            <app-address-input
                [form]="form"
                id="pohodaInsuranceCompanyBranchAddress"
                label="service.payments.form.pohodaInsuranceCompanyBranchAddress"
                class="fr-2"
            ></app-address-input>
            <div class="fr-3"></div>
        </div>
    </div>

    <app-action-buttons
        [primaryButtonDisability]="!!overlapErrorMessage()"
        (primaryClickEvent)="submit()"
        (secondaryClickEvent)="cancel()"
    ></app-action-buttons>
}
